const createVirtualPageLoad = name => {
  if (
    window.sessionCamRecorder &&
    window.sessionCamRecorder.createVirtualPageLoad
  )
    window.sessionCamRecorder.createVirtualPageLoad(name);
};

const closeVirtualPage = () => {
  if (window.sessionCamRecorder && window.sessionCamRecorder.closeVirtualPage)
    window.sessionCamRecorder.closeVirtualPage();
};

export default {
  createVirtualPageLoad,
  closeVirtualPage,
};
